module.exports = __webpack_public_path__ + "img/cpany23.6f96be99.png";